import { FC, useCallback, useEffect, useRef, useState, useSyncExternalStore } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../Services/AuthService';
import axios from 'axios';
import { HeaderWrapper, LoaderWrapper, SigninOidcWrapper, TextWrapper } from './SigninOidc.styled';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import Header from '../Header/Header';
import { getUser } from '../../Services/LondunarkerfiAPIService';

const SigninOidc: FC = () => {
  const navigate = useNavigate();
  const authenticated = useRef(false);
  const [error, setError] = useState('');
  const sessionExpired = useSyncExternalStore(authService.subscribe, authService.isSessionExpired);

  const loadUser = useCallback(async () => {
    setError('');
    try {
      const userData = await getUser();
      navigate(userData?.isReweighingUser ? '/reweighting' : '/landings', { replace: true });
    } catch (err) {
      if (axios.isAxiosError(err) && err.response?.status === 403) {
        navigate('/unauthorized', { replace: true });
      } else {
        setError('Ekki tókst að sækja aðgangsupplýsingar. Reyndu aftur.');
      }
    }
  }, [navigate]);

  useEffect(() => {
    if (!sessionExpired && authenticated.current) void loadUser();
  }, [sessionExpired, loadUser]);

  useEffect(() => {
    let active = true;
    const handleLoginChange = async () => {
      try {
        const user = await authService.completeAuthentication();
        // Svar úr sprettiglugga er afhent upprunalega glugganum af auðkenningarsafninu.
        if (!active || !user) return;
        authenticated.current = true;
        await loadUser();
      } catch (error) {
        if (!active) return;
        const missingState = error instanceof Error &&
          ['No state in response', 'No matching state found in storage'].includes(error.message);
        setError(missingState
          ? 'Innskráningartengillinn er útrunninn eða þegar notaður. Skráðu þig inn aftur.'
          : 'Ekki tókst að ljúka innskráningu. Reyndu að skrá þig inn aftur.');
      }
    };
    void handleLoginChange();
    return () => { active = false; };
  }, [loadUser]);


  return (
    <SigninOidcWrapper>
      <HeaderWrapper>
        <Header isAuthorized={false} />
      </HeaderWrapper>
      <LoaderWrapper>
        {error ? <Box>
          <Alert severity="error">{error}</Alert>
          <Button sx={{ mt: 2 }} onClick={() => authenticated.current
            ? void loadUser()
            : void authService.login().catch(() => setError('Ekki tókst að opna innskráningu. Reyndu aftur.'))}>
            Reyna aftur
          </Button>
        </Box> : <>
          <TextWrapper>
            <Typography variant='h5' color={'primary'}>
            Unnið úr auðkenningu
            </Typography>
          </TextWrapper>
          <Box sx={{ display: 'flex', paddingTop: '0.5em' }}>
            <CircularProgress />
          </Box>
        </>}
      </LoaderWrapper>
    </SigninOidcWrapper>
  );
}

export default SigninOidc;
